import React, { Component } from 'react';
import ReactTable from 'react-table';
import { Link } from 'react-router-dom';
import axios from 'axios';
import PropTypes from 'prop-types';

class BasicTable extends Component {
  state = {
    loading: true,
    tableData: []
  };

  componentDidMount = () => {
    if (!this.props.fetch) {
      this.setState({
        loading: false,
        tableData: this.props.data
      });
    } else {
      this.fetchData();
    }
  };

  componentDidUpdate = (prevProps) => {
    if (JSON.stringify(prevProps.data) !== JSON.stringify(this.props.data)) {
      this.setState({
        tableData: this.props.data
      });
    }

    if (prevProps.url !== this.props.url) {
      this.fetchData();
    }

    if (prevProps.refresh !== this.props.refresh) {
      this.fetchData();
    }

    if (prevProps.additionalPostData !== this.props.additionalPostData) {
      this.fetchData();
    }
  };

  fetchData = () => {
    if (this.props.httpMethod === 'post') {
      return this.postFetchData();
    }

    axios
      .get(this.props.url)
      .then(({ data }) => {
        let tableData = [...data];

        if (this.props.keyName) {
          tableData = data[this.props.keyName];
        }

        this.setState({
          loading: false,
          tableData: tableData
        });

        return tableData;
      })
      .then((d) => {
        if (this.props.returnData) {
          this.props.returnData(d);
        }
      })
      .catch(() => {
        this.setState({
          loading: false
        });
      });
  };

  postFetchData = () => {
    this.setState({ loading: true });

    axios
      .post(this.props.url, { ...this.props.additionalPostData })
      .then(({ data }) => {
        let tableData = [...data];

        if (this.props.keyName) {
          tableData = data[this.props.keyName];
        }

        this.setState({
          loading: false,
          tableData: tableData
        });

        return tableData;
      })
      .then((d) => {
        if (this.props.returnData) {
          this.props.returnData(d);
        }
      })
      .catch(() => {
        this.setState({
          loading: false
        });
      });
  };

  render() {
    if (!this.props.columns.length) {
      return <p>No columns specified.</p>;
    }

    return (
      <ReactTable
        data={this.state.tableData}
        defaultPageSize={this.props.defaultPageSize}
        className="-ui -striped -table"
        columns={this.props.columns}
        loading={this.state.loading}
        loadingText={`Loading ${this.props.entityName}`}
        minRows={5}
        multiSort={false}
        noDataText={`No ${this.props.entityName} Available`}
        rowsText={`${this.props.entityName}`}
      />
    );
  }
}

export default BasicTable;

BasicTable.defaultProps = {
  additionalPostData: {},
  columns: [],
  defaultPageSize: 20,
  entityName: 'Rows',
  fetch: true,
  httpMethod: 'get',
  refresh: false,
  returnData: false,
  subComponent: null
};

BasicTable.propTypes = {
  additionalPostData: PropTypes.object,
  columns: PropTypes.array,
  data: PropTypes.array,
  entityName: PropTypes.string,
  fetch: PropTypes.bool,
  httpMethod: PropTypes.string,
  keyName: PropTypes.string,
  refresh: PropTypes.bool,
  url: PropTypes.string
};
